import { render, staticRenderFns } from "./PsEventTA.vue?vue&type=template&id=1d446698&scoped=true&"
import script from "./PsEventTA.vue?vue&type=script&lang=js&"
export * from "./PsEventTA.vue?vue&type=script&lang=js&"
import style0 from "./PsEventTA.vue?vue&type=style&index=0&id=1d446698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d446698",
  null
  
)

export default component.exports